import React from 'react'
import Parser from 'html-react-parser';
import Layout from '../components/layout'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import MembershipSplash from '../../static/img/splash-membership-2021.jpg'

class MembershipPage extends React.Component {
     constructor(props) {
          super(props);
     }
     render() {
          return (
            <Layout className="membership-page">

                 <div
                      className="splash jumbotron"
                      style={{minHeight:'400px',marginBottom:'0px', backgroundImage:`url(${MembershipSplash})`, backgroundSize:'cover', backgroundPosition: 'center center'}}
                    >

                    <h1 className="text-white text-center wow fadeInDown">MEMBERSHIP</h1>
               </div>

               <div className="container-fluid  container-students pt-4 pb-4">
                    <div className="container">
                         {this.props.data.MembershipData.edges.map((item, index) => {
                              return (
                                   <div className="container-fluid container-timeline research_data">
                                        <div className="container">
                                             <div className="row">
                                                  <div className="col-lg-6 text-left wow fadeInLeft">
                                                       <h2 className="text-primary">{Parser(item.node.title)}</h2>
                                                       <p>{Parser(item.node.description)}</p>
                                                  </div>
                                                  <div className="col-lg-1"></div>
                                                  <div className="col-lg-5 wow fadeInRight">
                                                       <img src={item.node.image[0].url} alt="Rice Students Meeting" />
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              )
                         })
                         }
                    </div>
               </div>


            </Layout>
       );
  }
 }
 export const query = graphql`
      query MembershipData {
           MembershipData: allFlamelinkMembershipContent {
                edges {
                     node {
                          title,
                          description,
                          image{
                            url
                          }
                     }
                }
           }
      }
 `;
export default MembershipPage
